<template>
  <div class="featured-magazine-section">
    <div v-if="images.length">
      <CarouselWidget
        class="magazine-carousel"
        :items="images"
        :itemsToShow="itemsToShow"
        :nav="!xsOnly"
        nav-inside
      >
        <template #item="{ item }">
          <img loading="lazy" :src="item" />
        </template>
      </CarouselWidget>
    </div>

    <div>
      <div class="text-h4 font-weight-bold">{{ title }}</div>
      <div class="text-justify" v-html="text"></div>
      <div class="d-flex justify-end">
        <v-btn class="text-none" color="primary" depressed large :to="to">
          Ler revista
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import { formatToURL } from "../../utils/formatToURL";

const _carouselSettings = {
  itemsToShow: {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },
};

const _data = {
  ..._carouselSettings,
};

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    img: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ..._data,
  }),
  computed: {
    parsedImg() {
      return this.files + this.img?.featured?.path + "?resize=1&w=600";
    },
    images() {
      if (!this.img?.list) return [];

      return this.img.list.map(({ path }) => {
        return this.files + path + "?resize=1&w=600";
      });
    },
    to() {
      const slug = formatToURL(this.title);

      return `/almanaque/${slug}-${this.id}`;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    CarouselWidget,
  },
};
</script>

<style lang="scss" scoped>
.featured-magazine-section {
  display: grid;
  grid-template-columns: 175px auto;
  gap: 16px;

  img {
    max-height: 500px;
  }
}

@media screen and (max-width: 960px) {
  .featured-magazine-section {
    grid-template-columns: repeat(2, calc(50% - 8px));

    img {
      max-height: initial !important;
      width: 100%;
    }
  }
}
@media screen and (max-width: 600px) {
  .featured-magazine-section {
    grid-template-columns: 100%;
  }
}

.magazine-carousel::v-deep {
  .carousel-widget-nav-item-next,
  .carousel-widget-nav-item-prev {
    display: none;
    background-color: rgba(255, 255, 255, 0.5) !important;

    i {
      color: rgba(0, 0, 0, 1) !important;
    }
  }

  :hover {
    .carousel-widget-nav-item-next,
    .carousel-widget-nav-item-prev {
      display: flex;
    }
  }
}
</style>
